import { render, staticRenderFns } from "./srtx.vue?vue&type=template&id=27db1689&scoped=true"
import script from "./srtx.vue?vue&type=script&lang=js"
export * from "./srtx.vue?vue&type=script&lang=js"
import style0 from "./srtx.vue?vue&type=style&index=0&id=27db1689&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27db1689",
  null
  
)

export default component.exports